import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/Rx';

@Injectable()
export class ProductModal {
  public modalProduct: any;
  constructor() { }
}
